export enum AlignmentOptions {
  LEFT,
  CENTER,
  RIGHT,
}

export type StringAlignment = 'left' | 'center' | 'right';

const numericToString: Record<number, StringAlignment> = {
  [AlignmentOptions.LEFT]: 'left',
  [AlignmentOptions.CENTER]: 'center',
  [AlignmentOptions.RIGHT]: 'right',
};

export const resolveAlignment = (value: number): StringAlignment =>
  numericToString[value] ?? 'center';

const numericToFlex: Record<number, string> = {
  [AlignmentOptions.LEFT]: 'flex-start',
  [AlignmentOptions.CENTER]: 'center',
  [AlignmentOptions.RIGHT]: 'flex-end',
};

export const resolveJustifyContent = (value: number): string =>
  numericToFlex[value] ?? 'center';

export const resolveTextAlign = (value: number): StringAlignment =>
  resolveAlignment(value);

export const resolveFlexAlignment = (value: number): string =>
  numericToFlex[value] ?? 'center';
